import React from "react"
import { connect } from "react-redux"
import Modal from "../common/components/Modal"
import * as identifiersActions from "../identifiers/actions"

const InfantExplanationModal = ({
  show,
  heading,
  explanation,
  closeModal,
  restartInterview,
}) =>
  show ? (
    <Modal
      heading={heading}
      body={explanation}
      cancelClick={closeModal}
      buttonText="Restart interview"
      cancelText="Okay"
      buttonClick={restartInterview}
    />
  ) : (
    <span />
  )

const mapStateToProps = state => ({
  show: state.identifiers.infantExplanation,
  explanation:
    state.identifiers.infantExplanation &&
    state.identifiers.infantExplanation.text,
  heading:
    state.identifiers.infantExplanation &&
    state.identifiers.infantExplanation.heading,
})

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(identifiersActions.setInfantExplanation(null)),
  restartInterview: () => window.location.reload(),
})

const InfantExplanationModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfantExplanationModal)

export { InfantExplanationModalContainer as default, InfantExplanationModal }



// WEBPACK FOOTER //
// ./assets/modals/InfantExplanationModal.js